export const FORENSICS_PAGE_SIZE_OPTIONS = [5, 10, 25] as const;
export const FORENSICS_DEFAULT_PAGE_SIZE = 10;

export type ForensicsPageSize = (typeof FORENSICS_PAGE_SIZE_OPTIONS)[number];

export function isForensicsPageSize(value: number): value is ForensicsPageSize {
  return (FORENSICS_PAGE_SIZE_OPTIONS as readonly number[]).includes(value);
}

export function forensicsPageCount(total: number, pageSize: number): number {
  if (total <= 0 || pageSize <= 0) return 0;
  return Math.ceil(total / pageSize);
}
